import { useEffect } from "react";
import { X } from "lucide-react";

export function Sheet({ open, onClose, title, children, testId }) {
  useEffect(() => {
    if (!open) return;
    const y = window.scrollY;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      window.scrollTo({ top: y, behavior: "instant" });
    };
  }, [open]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[1100] flex items-end sm:items-center justify-center" data-testid={testId}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-[480px] max-h-[92dvh] overflow-y-auto bg-card border border-border rounded-t-3xl sm:rounded-3xl p-5 pb-[max(20px,env(safe-area-inset-bottom))] fade-up">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-medium">{title}</h2>
          <button data-testid="sheet-close-btn" onClick={onClose} className="p-2 -mr-2 rounded-full hover:bg-secondary text-muted-foreground"><X size={20} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}
